import { useState, useEffect } from "react";
import { EMPLOYEE_MANAGEMENT_SERVICE } from "src/utils/Api";
import __ from "src/utils/Translations";
import useHasPermission from "src/utils/hooks/security/useHasPermission";
import { employeeEmployeePermissionRead } from "src/utils/RoleBasedSecurity/permissions";
import sendBatchRequests from "src/utils/Api/sendBatchRequests";
import { mappingOptions } from "src/utils/Api/modifyResponse";

export default function useEmployees(
  asOption = false,
  filterField = null,
  filterValue = null,
  idAsIri = false,
  noFetching = false,
  batchParams = 50
) {
  const [data, setData] = useState([]);

  const hasPermission = useHasPermission(employeeEmployeePermissionRead);
  const skipAction = !hasPermission || noFetching;

  useEffect(() => {
    const fetchData = async () =>
      sendBatchRequests({
        skipAction,
        filterField,
        filterValue,
        idAsIri,
        asOption,
        IRI_PREFIX,
        requestParams: {
          service: EMPLOYEE_MANAGEMENT_SERVICE,
          path: "/employees",
          method: "GET",
          mockData,
          itemsPerPage: batchParams,
        },
        mappingType: mappingOptions.byFirstNameAndLastName,
        setData,
      });

    fetchData();
  }, [filterField, filterValue, idAsIri, asOption, batchParams, skipAction]);

  return data;
}

export const IRI_PREFIX = "/api/employee-management/v1/rest/employees";

export const mockData = [
  {
    id: "a43275e4-eeb2-11ea-adc1-0242ac1200021",
    firstName: "Jan",
    lastName: "Kowalski",
    companyId: "a43275e4-eeb2-11ea-adc1-0242ac1200021",
    username: "10clouds344222281",
    email: "jan.kowalski@gmial.com",
    active: true,
    employeeGroup: "Użytkownicy",
    fk: "3c3275af-7247-470e-9397-d114957deb71",
  },
];
